module.exports = __webpack_public_path__ + "img/ojk.f5d568cc.png";